export default __webpack_public_path__ + "static/media/americanexpress.7dd41070.png";